import { render, staticRenderFns } from "./AddHolidayDialog.vue?vue&type=template&id=b760c7c4"
import script from "./AddHolidayDialog.vue?vue&type=script&lang=js"
export * from "./AddHolidayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports